/* PayPal Pay Later message: keep the amount in step with the selected variant.
   VP audit 2026-09-05 (C05): the previous version only listened for a native change event and a
   URL poll, and the message was seen holding the 5-quart amount after switching to the cubic-foot
   bag. This version also subscribes to the theme's variantChange event, watches the hidden variant
   id input, and updates data-pp-amount. PayPal observes this attribute and owns the
   message lifecycle. VP repair 2026-10-23: preserve its iframe on variant changes. */
(function () {
  if (window.__vpPpPaylaterLoaded) return;
  window.__vpPpPaylaterLoaded = true;

  function variants() {
    try { var s = document.getElementById('pp-variants-data'); return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function currentId() {
    var u = new URLSearchParams(location.search).get('variant');
    if (u) return u;
    var sel = document.querySelector('form[action*="/cart/add"] [name="id"]:checked');
    if (sel) return sel.value;
    var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return inp ? inp.value : null;
  }
  function priceFor(id) {
    var vs = variants(); if (!vs) return null;
    for (var i = 0; i < vs.length; i++) { if (String(vs[i].id) === String(id)) return vs[i].price / 100; }
    return null;
  }
  // PayPal owns the rendered iframe. Updating its amount is sufficient:
  // the SDK observes data-pp-* attributes and refreshes the existing message.
  // Never clear the container or call render() during a variant change.
  function render(el, amount) {
    el.setAttribute('data-pp-amount', amount);
  }
  function refresh(force) {
    var el = document.querySelector('[data-pp-message]'); if (!el) return;
    var p = priceFor(currentId()); if (p == null) return;
    var amount = p.toFixed(2);
    if (!force && String(el.getAttribute('data-pp-amount')) === String(amount)) return;
    render(el, amount);
  }
  function scheduleRefresh() { setTimeout(refresh, 60); setTimeout(refresh, 400); }

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && (t.name === 'id' || (t.closest && t.closest('variant-selects,variant-radios,.product-form,form[action*="/cart/add"]')))) scheduleRefresh();
  }, true);

  function subscribeToTheme() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, scheduleRefresh);
      if (window.PUB_SUB_EVENTS.optionValueSelectionChange) window.subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, scheduleRefresh);
      return true;
    }
    return false;
  }
  var subTries = 0;
  (function trySub() { if (!subscribeToTheme() && subTries++ < 25) setTimeout(trySub, 200); })();

  try {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && window.MutationObserver) {
      new MutationObserver(scheduleRefresh).observe(form, { subtree: true, attributes: true, attributeFilter: ['value', 'checked'], childList: true });
    }
  } catch (e) {}

  var last = location.href;
  setInterval(function () { if (location.href !== last) { last = location.href; refresh(); } }, 700);
  document.addEventListener('veryplants:price-updated', scheduleRefresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 1000); }); else setTimeout(refresh, 1000);
})();
